<template>
  <el-container v-loading="loading" class="outer">
    <el-container>
      <el-header style="height: 40px;">
        <el-row style="margin: 10px 0 10px 0px; ">
          <el-col :span="8">
            <span>当前目录信息和层级关系</span>
            <el-select v-model="orderKey" placeholder="请选择" size="small"
              style="margin-left: 10px;vertical-align: middle;" @change="catalogChange">
              <el-option v-for="(item, index) in orderRuleList" :key="index" :label="item.orderName"
                :value="item.orderCode">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="16" style="display: flex;justify-content: flex-end">
            <el-button v-if="isChild==1" size="small" @click="openDisabledDialog">单独禁用</el-button>
            <el-button :loading="rollbackLoading" :disabled="catalogInit === '0'" type="info" size="small" @click="rollback">
              恢复至最后一次发布状态
            </el-button>
            <el-button :loading="saveChangeLoading" type="primary" size="small" @click="saveChange('')">
              保存更改
            </el-button>
            <el-button :loading="publishChangeLoading" type="primary" size="small" @click="publishChange">
              发布
            </el-button>
          </el-col>
        </el-row>
      </el-header>
      <el-container>
        <el-main>
          <el-card v-for="(item, key) in data" :key="key" class="box-card" shadow="hover">
            <div slot="header" class="clearfix">
              <span>包含{{ item.name }}</span>
              <el-button type="text" icon="el-icon-plus" style="color:var(--theme-color)!important;padding-right: 10px;"
                @click="addItem(item, key)">
                新增{{ item.name }}
              </el-button>
            </div>
            <div v-for="(child, index) in item[item.key + 'List']" :key="index" class="item">
              <span class="content">
                <span :title="child[item.key + 'Name']" class="text">{{ child[item.key + "Name"] }}</span>
                <span v-if="child.isActive === 1" class="danger">已禁用</span>
              </span>
              <el-button :disabled="child.orderNum === 1" type="text" style="color:var(--theme-color)"
                @click="move(index, item, 'up')">
                上移
              </el-button>
              <el-button :disabled="child.orderNum === item[item.key + 'List'].length" type="text" style="color:var(--theme-color)"
                @click="move(index, item, 'down')">
                下移
              </el-button>
              <el-button style="color:var(--theme-color)!important" type="text" @click="toggleDisabled(child)">
                {{ child.isActive ? "启用" : "禁用" }}
              </el-button>
              <el-button v-if="item.name === $titles.child" :disabled="child.isPublish === 1" type="text"
                style="color:var(--theme-color)!important" @click="editChild(child[item.key + 'Name'], index, key,child.childId)">
                编辑
              </el-button>
              <el-button :disabled="child.isPublish === 1" type="text" style="color:#EE7171!important"
                @click="delChild(item, index)">
                删除
              </el-button>
            </div>
          </el-card>
        </el-main>
      </el-container>
    </el-container>
    <el-aside width="250px" style="position: relative;">
      <preview-tree ref="previewTree" :tree-data="data" :csget-params="csgetParams"></preview-tree>
    </el-aside>
    <el-dialog v-dialogDrag :visible.sync="professionDialogVisible" :close-on-click-modal="false" :close-on-press-escape="false"
      title="添加专业" custom-class="profession-dialog" destroy-on-close width="500px">
      <el-form ref="form" :model="form" label-position="top" size="small">
        <el-row>
          <el-col :span="24">
            <el-form-item label="选择专业">
              <el-select v-model="form.spec" placeholder="请选择" size="small" style="width: 100%" value-key="specId"
                multiple>
                <el-option v-for="(item, inedx) in filteredSpecList" :key="inedx" :label="item.specName" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="professionDialogVisible = false">取 消</el-button>
        <el-button type="primary" size="small" @click="submit('spec')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog v-dialogDrag :visible.sync="childDialogVisible" :close-on-click-modal="false" :close-on-press-escape="false"
      :title="`添加${$titles.child}`" custom-class="profession-dialog" destroy-on-close width="500px">
      <el-form ref="childform" :model="form" label-position="top" size="small">
        <el-row>
          <el-col :span="24">
            <el-form-item :label="`请输入${$titles.child}名称`">
              <el-input ref="child" v-model="form.child" maxlength="80" size="small" show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="childDialogVisible = false">取 消</el-button>
        <el-button type="primary" size="small" @click="submit('child')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog v-dialogDrag :visible.sync="stageDialogVisible" :close-on-click-modal="false" :close-on-press-escape="false"
      title="添加阶段" custom-class="profession-dialog" destroy-on-close width="500px">
      <el-form ref="form" :model="form" label-position="top" size="small">
        <el-row>
          <el-form-item label="选择阶段">
            <el-select v-model="form.stage" placeholder="请选择" size="small" style="width: 100%" value-key="stageId"
              multiple>
              <el-option v-for="(item, index) in filteredStageList" :key="index" :label="item.stageName" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="">
            <el-button type="primary" icon="el-icon-refresh" plain size="small" @click="refreshEnterpriseStages">
              刷新企业阶段
            </el-button>
          </el-form-item>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="stageDialogVisible = false">取 消</el-button>
        <el-button type="primary" size="small" @click="submit('stage')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog v-dialogDrag :visible.sync="catalogDialogVisible" :close-on-click-modal="false" :close-on-press-escape="false"
      title="关键目录维护" custom-class="profession-dialog" width="500px">
      <el-form ref="form" :model="form" label-position="top" size="small">
        <el-row>
          <el-col :span="24">
            <el-form-item label="请先选择您想要的目录信息和层级关系">
              <el-select v-model="orderKey" placeholder="请选择" size="small" style="width: 100%" @change="catalogChange">
                <el-option v-for="(item, index) in orderRuleList" :key="index" :label="item.orderName"
                  :value="item.orderCode">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="catalogDialogVisible = false">取 消</el-button>
        <el-button type="primary" size="small" @click="initCatalog">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 单独禁用 -->
    <el-dialog v-dialogDrag :visible.sync="disabledDialogVisible" :close-on-click-modal="false"
      :close-on-press-escape="false" title="单独禁用" custom-class="disabled-dialog" destroy-on-close width="660px">
      <el-form ref="form" :model="disabledForm" label-position="left" size="small">
        <div v-for="(item, key) in selectData" :key="key" style="display:inline-block">
          <el-form-item v-if="item.key=='spec'" label="专业:">
            <el-select v-model="disabledForm.specId" placeholder="请选择专业" size="small" style="width: 167px"
              @change="queryDisabled">
              <el-option v-for="(item, index) in item.childList" :key="index" :label="item.specName"
                :value="item.specId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="item.key=='stage'" label="阶段:">
            <el-select v-model="disabledForm.stageId" placeholder="请选择阶段" size="small" style="width: 167px"
              @change="queryDisabled">
              <el-option v-for="(item, index) in item.childList" :key="index" :label="item.stageName"
                :value="item.stageId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="item.key=='child'" :label="$titles.child+':'">
            <el-select v-model="disabledForm.childId" :placeholder="`请选择${$titles.child}`" size="small" style="width: 167px"
              @change="queryDisabled">
              <el-option v-for="(item, index) in item.childList" :key="index" :label="item.childName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" empty-text="" height="500px" border>
          <template slot="empty">
            <img :src="zanwu" />
            <p style="font-size:16px;color:#000;">暂无数据</p>
          </template>
          <el-table-column show-overflow-tooltip align="center" label="名称" prop="tabName">
          </el-table-column>
          <el-table-column label="状态" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.status=='启用'" style="color:var(--theme-color)">已启用</span>
              <span v-if="scope.row.status=='禁用'" style="color:#FD4251">已禁用</span>
            </template>
          </el-table-column>
          <el-table-column label="设置" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.status=='启用'" style="color:#FD4251;cursor: pointer;"
                @click="enabled(1,scope.row)">禁用</span>
              <span v-else style="color:var(--theme-color);cursor: pointer;" @click="enabled(2,scope.row)">启用</span>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="disabledDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import service from "@/CommonDP/service/folder-service";
import PreviewTree from "../previewTree.vue";
import enterpriseService from "@/CommonDP/service/enterprise-service";

export default {
  components: { PreviewTree },
  data() {
    return {
      loading: false,
      rollbackLoading: false,
      saveChangeLoading: false,
      publishChangeLoading: false,
      catalogDialogVisible: false,
      professionDialogVisible: false,
      childDialogVisible: false,
      stageDialogVisible: false,
      orderRuleList: [],
      orderKey: "",
      directoryStatus: null,
      selectedOrderKey: "",
      data: [],
      specList: [],
      stageList: [],
      curItem: null,
      curEditIndex: -1,
      form: {
        spec: [],
        stage: [],
        child: ""
      },
      csgetParams: {},
      curEditId: "",
      isChild: 0,
      disabledDialogVisible: false,
      disabledForm: {
        prjId: "",
        specId: "",
        stageId: "",
        childId: "",
        enterpriseId: ""
      },
      selectData: [],
      tableData: [],
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      orignSpecList: [], // 未修改的专业目录
      orignChildList: [], // 未修改的子项目录
      orignStageList: [] // 未修改的阶段目录
    };
  },
  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj,
      catalogInit: (state) => state.projectMg.catalogInit,
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    filteredSpecList() {
      // 过滤已添加的数据
      if (!this.data.length) return this.specList;
      const index = this.data.findIndex((item) => item.key === "spec");
      if (index < 0) return [];
      if (!this.data[index].specList.length) return this.specList;
      console.log(index, 'index');
      console.log(this.data, 'index');
      return this.specList.filter((item) => {
        return !this.data[index].specList.map((d) => d.specId).includes(item.specId);
      });
    },
    filteredStageList() {
      // 过滤已添加的数据
      if (!this.data.length) return this.stageList;
      const index = this.data.findIndex((item) => item.key === "stage");
      if (index < 0) return [];
      if (!this.data[index].stageList.length) return this.stageList;
      return this.stageList.filter((item) => {
        return !this.data[index].stageList.map((d) => d.stageId).includes(item.stageId);
      });
    }
  },
  watch: {
    directoryStatus(newValue) {
      if (newValue === "0") this.catalogDialogVisible = true;
      if (newValue === "2") this.setCatalogToken("1");
      this.csgetParams = this.getParams();
    },
    prjInfo(newValue) {
      if (newValue.prjId) {
        this.fetchData();
      }
    },
    csgetParams: {
      deep: true,
      handler(value) {
        if (!this.checkSave()) {
          this.$store.dispatch("setCheckSave", '1');
          window.onbeforeunload = null;
          window.onbeforeunload = function() {
            return "";
          };
        } else {
          this.$store.dispatch("setCheckSave", '0');
          window.onbeforeunload = null;
        }
      }
    }
  },
  created() {
    this.queryAllDic();
    this.fetchData();
  },
  beforeDestroy() {
    window.onbeforeunload = null;
  },

  methods: {
    ...mapActions(["setCatalogToken"]),
    initCatalog() {
      this.saveChange("init");
      this.catalogDialogVisible = false;
    },
    catalogChange() {
      if (this.catalogInit === "1") {
        this.$message.warning("目录已经发布，不能修改");
        this.orderKey = this.selectedOrderKey;
      } else {
        this.saveChange("init");
      }
    },
    fetchData() {
      this.loading = true;
      service
        .queryKeyCatalogList({ prjId: this.prjInfo.prjId })
        .then((res) => {
          this.loading = false;
          if (res.result === "0") {
            const { orderRuleList, orderKey, directoryStatus, orderRule = [] } = res.data;
            this.$set(res.data, "childItemlist", res.data.childList);
            this.orderRuleList = orderRuleList;
            this.orderKey = orderKey;
            this.selectedOrderKey = orderKey;
            this.directoryStatus = directoryStatus;
            this.isChild = orderKey.indexOf("child") !== -1 ? 1 : 2;
            this.data = orderRule.map((rule) => {
              return {
                ...rule,
                [rule.key + "List"]: res.data[rule.key + "List"]
              };
            });

            this.csgetParams = this.getParams();
            const specFiltered = this.data.filter(item => item.key === "spec");
            const childItemFiltered = this.data.filter(item => item.key === "child");
            const stageFiltered = this.data.filter(item => item.key === "stage");

            // 原数据
            this.orignSpecList = [];
            this.orignChildList = [];
            this.orignStageList = [];
            if (specFiltered.length > 0) {
              const specList = [...specFiltered[0].specList] || [];
              specList.forEach(item => {
                const spec = { ...item };
                this.orignSpecList.push(spec);
              });
            }
            if (childItemFiltered.length > 0) {
              const childList = [...childItemFiltered[0].childList] || [];
              childList.forEach(item => {
                const child = { ...item };
                this.orignChildList.push(child);
              });
            }
            if (stageFiltered.length > 0) {
              const stageList = [...stageFiltered[0].stageList] || [];
              stageList.forEach(item => {
                const stage = { ...item };
                this.orignStageList.push(stage);
              });
            }
            setTimeout(() => {
              if (this.catalogInit === "1") {
                this.$refs.previewTree.refresh();
              }
            }, 2000);
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    queryAllDic() {
      const params = { enterpriseId: this.enterpriseId };
      service.queryspeclist2(params).then((res) => {
        this.specList = res.data;
      });
      service.queryStageList(params).then((res) => {
        this.stageList = res.data;
      });
    },
    getParams() {
      const stageFiltered = this.data.filter((item) => item.key === "stage");
      const specFiltered = this.data.filter((item) => item.key === "spec");
      const childItemFiltered = this.data.filter((item) => item.key === "child");
      const params = {
        enterpriseId: this.enterpriseId,
        orderKey: this.orderKey,
        prjId: this.prjInfo.prjId,
        stageList: stageFiltered.length ? stageFiltered[0].stageList || [] : [],
        specList: specFiltered.length ? specFiltered[0].specList || [] : [],
        childList: childItemFiltered.length ? childItemFiltered[0].childList || [] : []
      };
      return params;
    },

    async refreshEnterpriseStages() {
      await enterpriseService.refreshEnterpriseStages(this.enterpriseId);
      const res = await service.queryStageList({
        enterpriseId: this.enterpriseId
      });
      this.stageList = res.data;
    },
    publishChange() {
      if (this.directoryStatus === "0") {
        this.$message.warning("请先初始化目录");
        return;
      }
      this.publishChangeLoading = true;
      const params = this.getParams();
      this.csgetParams = this.getParams();
      var tt = this.csgetParams.orderKey.split(">").every((item) => {
        return this.csgetParams[item + "List"].length > 0;
      });
      if (tt) {
        this.$confirm("发布完成后，文档目录将同步修改，是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal: false,
          closeOnPressEscape: false
        }).then(() => {
          service
            .publishChange(params)
            .then((res) => {
              this.publishChangeLoading = false;
              if (res.result === "0") {
                this.$parent.fabutipsshowFu();
                this.$store.dispatch("setCatalogToken", "1"); // 发布过
                this.$message.success("发布成功");
                this.csgetParams = this.getParams();
                this.$refs.previewTree.refresh();
                this.fetchData();
              }
            })
            .catch(() => {
              this.publishChangeLoading = false;
            });
        }).catch(() => {
          this.publishChangeLoading = false;
        });
      } else {
        var item = this.csgetParams.orderKey.split(">");
        for (var i = 0; i < item.length; i++) {
          if (!this.csgetParams[item[i] + "List"].length) {
            if (item[i] === "child") {
              this.$message.warning(this.$titles.child + "不能为空");
              this.publishChangeLoading = false;
              break;
            } else if (item[i] === "stage") {
              this.$message.warning("阶段不能为空");
              this.publishChangeLoading = false;
              break;
            } else if (item[i] === "spec") {
              this.$message.warning("专业不能为空");
              this.publishChangeLoading = false;
              break;
            }
          }
        }
      }
    },
    saveChange(type) {
      this.saveChangeLoading = true;
      const params = this.getParams();
      this.csgetParams = this.getParams();
      service
        .saveChange(params)
        .then((res) => {
          this.saveChangeLoading = false;
          if (res.result === "0") {
            if (!type) this.$message.success("保存成功");
            this.fetchData();
          }
        })
        .catch(() => {
          this.saveChangeLoading = false;
        });
    },
    rollback() {
      if (this.directoryStatus !== "1") {
        this.$message.warning("暂无要恢复的数据");
        return;
      }
      this.$confirm("恢复至上一次发布状态后，当前修改内容将丢失并且不可找回，是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
        closeOnPressEscape: false
      }).then(async() => {
        this.rollbackLoading = true;
        service.rollback({ prjId: this.prjInfo.prjId })
          .then((res) => {
            this.rollbackLoading = false;
            if (res.result === "0") {
              this.$parent.fabutipsshowFu();
              this.$message.success("恢复成功");
              this.fetchData();
            }
          })
          .catch(() => {
            this.rollbackLoading = false;
          });
      });
    },
    addItem({ key }, index) {
      this.curItem = index;
      this.curEditId = "";
      this.curEditIndex = -1;
      switch (key) {
        case "spec":
          this.professionDialogVisible = true;
          break;
        case "child":
          this.childDialogVisible = true;
          this.form.child = "";
          this.$nextTick(() => {
            this.$refs.child.focus();
          });
          break;
        case "stage":
          this.stageDialogVisible = true;
          break;
        default:
          this.professionDialogVisible = true;
          break;
      }
    },
    submit(type) {
      this.$parent.queryfabutips();
      const num = this.data[this.curItem][type + "List"].length + 1;
      const enterpriseId = this.enterpriseId;
      const common = {
        prjId: this.prjInfo.prjId,
        isActive: 0,
        orderNum: num,
        isDelete: 0,
        enterpriseId,
        isOutSpec: ""
      };
      switch (type) {
        case "child":
          this.updateChildItem(common, type);
          break;
        case "spec":
          this.updateSpec(common, type, num);
          break;
        case "stage":
          this.updateStage(common, type, num);
          break;
      }
    },
    updateSpec(common, type, orderNum) {
      if (!this.form[type].length) {
        this.$message.warning("请先选择专业");
        return;
      }
      this.form[type].forEach((item) => {
        this.data[this.curItem][type + "List"].push({
          [type + "Id"]: item.specId,
          [type + "Name"]: item.specName,
          ...common,
          orderNum: orderNum++
        });
      });
      this.form.spec = [];
      this.professionDialogVisible = false;
      this.csgetParams = this.getParams();
    },
    updateChildItem(common, type) {
      if (!this.form[type]) {
        this.$message.warning("请先输入" + this.$titles.child + "名称");
        return;
      }
      var regExp = new RegExp('[\\\\|/:*<>?"]');
      if (regExp.test(this.form[type])) {
        this.$message.warning(this.$titles.child + '名称不能包含以下字符:\\ / : * " ? < > |');
        return;
      }
      if (this.form[type].length > 80) {
        this.$message.warning(this.$titles.child + "名称最多80字符");
        return;
      }
      const has = this.data[this.curItem][type + "List"].some((item) => item.childName === this.form[type] && item.childId !== this.curEditId);
      if (has) {
        this.$message.warning("当前" + this.$titles.child + "已存在");
        return;
      }
      if (this.curEditIndex > -1) {
        // 编辑子项
        this.data[this.curItem][type + "List"][this.curEditIndex].childName = this.form[type];
        this.data[this.curItem][type + "List"][this.curEditIndex].childId = this.form[type];
        this.curEditIndex = -1;
        this.form.child = "";
        this.childDialogVisible = false;
        return;
      }
      common = {
        childName: this.form[type],
        childId: this.form[type],
        ...common
      };

      this.data[this.curItem][type + "List"].push(common);
      this.form.child = "";
      this.childDialogVisible = false;
      this.csgetParams = this.getParams();
    },
    updateStage(common, type, orderNum) {
      if (!this.form[type].length) {
        this.$message.warning("请先选择阶段");
        return;
      }

      this.form[type].forEach((item) => {
        this.data[this.curItem][type + "List"].push({
          [type + "Id"]: item.stageId,
          [type + "Name"]: item.stageName,
          ...common,
          orderNum: orderNum++
        });
      });
      this.form.stage = [];
      this.stageDialogVisible = false;
      this.csgetParams = this.getParams();
    },
    move(index, data, direction) {
      const key = data.key + "List";
      const temp = data[key].splice(index, 1)[0];
      if (direction === "up") {
        data[key].splice(index - 1, 0, temp);
      } else {
        data[key].splice(index + 1, 0, temp);
      }
      this.$parent.queryfabutips();
      // 点击上下移以后 查询一下当前数据 防止点击预览 数据不是最新的
      this.csgetParams = this.getParams();
      this.dataSort(data, key);
    },
    toggleDisabled(child) {
      this.$parent.queryfabutips();
      // 点击禁用 启用以后 查询一下当前数据 防止点击预览 数据不是最新的
      this.csgetParams = this.getParams();
      child.isActive = 1 - (child.isActive || 0);
    },
    editChild(name, index, key, childId) {
      this.curItem = key;
      this.form.child = name;
      this.curEditIndex = index;
      this.curEditId = childId;
      this.childDialogVisible = true;
    },
    delChild(data, index) {
      this.$confirm("确认要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // 点击删除以后 查询一下当前数据 防止点击预览 数据不是最新的
        this.csgetParams = this.getParams();
        data[data.key + "List"].splice(index, 1);
        this.dataSort(data, data.key + "List");
        this.$parent.queryfabutips();
        this.$message({
          type: "success",
          message: "删除成功!"
        });
      });
    },
    dataSort(data, key) {
      data[key].forEach((ele, index) => (ele.orderNum = index + 1));
    },
    async openDisabledDialog() {
      const res = await service.queryKeyCatalogList({
        prjId: this.prjInfo.prjId
      });
      const { orderRule = [] } = res.data;
      this.dataList = orderRule.map((rule) => {
        return {
          ...rule,
          childList: res.data[rule.key + "List"]
        };
      });
      this.selectData = [];
      this.tableData = [];
      this.disabledForm.prjId = this.prjInfo.prjId;
      this.disabledForm.enterpriseId = this.enterpriseId;
      if (this.isChild === 1) {
        this.selectData = this.dataList.slice(0, this.dataList.length - 1);
        this.tableData = this.dataList.slice(this.dataList.length - 1, this.dataList.length)[0].childList;
        this.lastStr = this.dataList.slice(this.dataList.length - 1, this.dataList.length)[0].key;
        if (this.tableData.length > 0) {
          for (var i = 0; i < this.selectData.length; i++) {
            if (this.selectData[i].key === "child") {
              this.disabledForm[this.selectData[i].key + "Id"] = this.selectData[i].childList[0].id;
            } else {
              this.disabledForm[this.selectData[i].key + "Id"] = this.selectData[i].childList[0][this.selectData[i].key + "Id"];
            }
          }
          for (var a = 0; a < this.tableData.length; a++) {
            this.$set(this.tableData[a], "tabName", this.tableData[a][this.lastStr + "Name"]);
            this.$set(this.tableData[a], "tabId", this.tableData[a][this.lastStr + "Id"]);
            this.$set(this.tableData[a], "id", this.tableData[a].id);
            if (this.lastStr === "child") {
              this.disabledForm[this.lastStr + "Id"] = this.tableData[a].id;
            } else {
              this.disabledForm[this.lastStr + "Id"] = this.tableData[a].tabId;
            }
            const res = await service.queryDisabled(this.disabledForm);
            const status = res.data === true ? "禁用" : "启用";
            this.$set(this.tableData[a], "status", status);
          }
        }
        this.disabledDialogVisible = true;
      }
    },
    async queryDisabled() {
      console.log(this.tableData, "val");
      for (var a = 0; a < this.tableData.length; a++) {
        if (this.lastStr === "child") {
          this.disabledForm[this.lastStr + "Id"] = this.tableData[a].id;
        } else {
          this.disabledForm[this.lastStr + "Id"] = this.tableData[a].tabId;
        }
        const res = await service.queryDisabled(this.disabledForm);
        const status = res.data === true ? "禁用" : "启用";
        this.$set(this.tableData[a], "status", status);
      }
    },
    async enabled(val, row) {
      if (this.lastStr === "child") {
        this.disabledForm[this.lastStr + "Id"] = row.id;
      } else {
        this.disabledForm[this.lastStr + "Id"] = row.tabId;
      }
      if (val === 1) {
        await service.dynaDisabled(this.disabledForm);
        row.status = "禁用";
        this.$message.success("禁用成功");
      } else {
        await service.dynaEnabled(this.disabledForm);
        row.status = "启用";
        this.$message.success("启用成功");
      }
    },
    isObject(obj) {
      return Object.prototype.toString.call(obj) === "[object Object]";
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    // 深度判断两个数组是否完全相等
    equalsObj(oldData, newData) {
      // 类型为基本类型时,如果相同,则返回true
      if (oldData === newData) return true;
      if (
        this.isObject(oldData) &&
        this.isObject(newData) &&
        Object.keys(oldData).length === Object.keys(newData).length
      ) {
        // 类型为对象并且元素个数相同
        // 遍历所有对象中所有属性,判断元素是否相同
        for (const key in oldData) {
          if (Object.hasOwnProperty.call(oldData, key)) {
            if (!this.equalsObj(oldData[key], newData[key])) {
              // 对象中具有不相同属性 返回false
              return false;
            }
          }
        }
      } else if (
        this.isArray(oldData) &&
        this.isArray(oldData) &&
        oldData.length === newData.length
      ) {
        // 类型为数组并且数组长度相同
        for (let i = 0, length = oldData.length; i < length; i++) {
          if (!this.equalsObj(oldData[i], newData[i])) {
            // 如果数组元素中具有不相同元素,返回false
            return false;
          }
        }
      } else {
        // 其它类型,均返回false
        return false;
      }
      // 走到这里,说明数组或者对象中所有元素都相同,返回true
      return true;
    },
    // 检查保存
    checkSave() {
      const specList = this.csgetParams.specList || [];
      const childList = this.csgetParams.childList || [];
      const stageList = this.csgetParams.stageList || [];
      if (
        !this.equalsObj(this.orignSpecList, specList) ||
          !this.equalsObj(this.orignChildList, childList) ||
          !this.equalsObj(this.orignStageList, stageList)
      ) {
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
.el-container.outer {
  height: calc(100% + 20px);
  margin: -10px -32px -10px -20px;
  .el-container {
    height: calc(100% - 50px);
    .el-container {
      height: calc(100% - 60px);
      .el-main {
        height: 100%;
        display: flex;
        padding: 10px;
        /deep/ .el-card {
          width: 33%;
          margin: 10px;
          min-width: 320px;
          max-height: calc(100% - 22px);
          &__header {
            padding: 5px;
            background-color: rgb(232, 240, 254);
            .clearfix {
              height: 40px;
              line-height: 26px;
              text-align: center;
              & > span {
                position: relative;
                top: 5px;
                left: 40px;
              }
              .el-button {
                float: right;
              }
            }
          }
          &__body {
            max-height: calc(100% - 80px);
            overflow: auto;
            .item {
              border-bottom: 1px solid #ebeef5;
              padding: 8px 0 3px;
              display: flex;
              .content {
                width: 63%;
                display: flex;
                font-size: 15px;
                .danger {
                  color: #f56c6c;
                }
                .text {
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  max-width: 100px;
                  margin-right: 10px;
                }
              }
              .el-button {
                padding: 0 !important;
                position: relative;
                top: -5px;
                font-size: 10px;
                margin-left: 8px;
              }
            }
          }
        }
      }
      .el-footer {
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
    }
  }
  .el-aside {
    border-left: 1px solid rgb(235, 239, 255);
    .el-card {
      border: none;
      height: calc(100% - 5px);
      border-radius: 0;
      &__header {
        .clearfix {
          text-align: center;
          & > span {
            position: relative;
            top: 5px;
            left: -18px;
          }
          .el-button {
            float: left;
          }
        }
      }
      &__body {
        height: calc(100% - 100px);
        overflow: auto;
      }
    }
  }
  /deep/ .profession-dialog {
    border-radius: 5px;
    .el-dialog__body {
      padding: 20px;
      border-top: 1px solid #2e5bff1a;
      border-bottom: 1px solid #2e5bff1a;
    }
  }
  /deep/ .disabled-dialog {
    .el-form-item {
      display: inline-block;
      width: 251px;
      margin-bottom: 10px;
    }
  }
}
</style>
